"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

const LobbyDateTabs = ({ selectedDate, onDateChange, compact }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Kèo trực tuyến",
      dateLabel: today.format("DD-MM"),
      type: "live",
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      dateLabel: today.format("DD-MM"),
      type: "today",
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      dateLabel: tomorrow.format("DD-MM"),
      type: "tomorrow",
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD-MM"),
        type: "future",
      });
    }

    return options;
  }, [todayString]);

  return (
    <div
      className={`flex w-max items-center gap-2 ${
        compact ? "h-full" : "mb-4 mt-2 md:mb-6 md:mt-4"
      }`}
    >
      {dateOptions.map((opt) => {
        const isSelected = selectedDate === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onDateChange(opt.value)}
            className={`h-10 rounded-lg text-xsm font-semibold cursor-pointer flex flex-col items-center justify-center border transition-colors px-4 min-w-[110px] shrink-0
              ${
                isSelected ? "kbv-wr-tab-active" : "kbv-wr-tab-inactive"
              }`}
          >
            <span className="leading-none whitespace-nowrap">{opt.label}</span>
            {opt.type !== "live" && opt.dateLabel && (
              <span className="text-xs mt-0.5 opacity-70 leading-none">
                {opt.dateLabel}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default LobbyDateTabs;
